import React from 'react';
import { Field, FieldProps, useFormikContext } from 'formik';
import { Button, Col, Input, Label, Modal, Row } from 'reactstrap';
import ErrorTooltip from 'Components/ErrorTooltip';

const LOAdjustmentPopUp = ({
    state,
    setState,
    tog_backdrop,
    target,
    index,
    handleSave
}: {
    state: boolean;
    setState: (val: boolean) => void;
    tog_backdrop: () => void;
    target: string;
    index: number;
    handleSave: (index: number, values: any, setFieldValue: any) => void;
}) => {
    const {
        values,
        errors,
        handleBlur,
        touched,
        handleChange,
        setFieldValue,
        initialValues,
    }: {
        values: any;
        errors: any;
        touched: any;
        handleBlur: any;
        handleChange: any;
        setFieldValue: any;
        initialValues: any;
    } = useFormikContext();

    const showToolTip = () => {
        return (
            errors?.lubeOil?.[index] &&
            touched?.lubeOil?.[index] &&
            (errors.lubeOil[index]?.adjustment_quantity || errors.lubeOil[index]?.adjustment_reason)
        );
    };

    return (
        <Modal
            size='md'
            isOpen={state}
            toggle={() => {
                tog_backdrop();
            }}
            backdrop='static'
            id={target}
            key={`${state}_${index}`}
        >
            <div className='modal-header p-2'>
                <h5 className='modal-title'>Lube Oil Adjustment</h5>
                <button
                    type='button'
                    className='close'
                    aria-label='Close'
                    onClick={() => {
                        if (values?.lubeOil?.[index]?.adjustment_quantity || errors?.lubeOil?.[index]?.adjustment_reason) {
                            const hasId = values?.lubeOil?.[index]?.id;
                            const quantity = hasId
                                ? initialValues?.lubeOil?.[index]?.adjustment_quantity ?? 0
                                : 0;
                            const reason = hasId
                                ? initialValues?.lubeOil?.[index]?.adjustment_reason ?? ''
                                : '';
                            setFieldValue(`lubeOil.${index}.adjustment_quantity`, quantity);
                            setFieldValue(`lubeOil.${index}.adjustment_reason`, reason);
                            const updatedBatch = {
                                ...values?.lubeOil?.[index],
                                adjustment_quantity: quantity,
                                adjustment_reason: reason,
                            };
                            handleSave(index, { ...values, lubeOil: { ...values.lubeOil, [index]: updatedBatch } }, setFieldValue);
                        } else {
                            setState(false);
                        }
                    }}
                >
                    <span aria-hidden='true'>&times;</span>
                </button>
            </div>
            <div className='modal-body'>
                <Row className='mb-2'>
                    <Col lg={12}>
                        <small>
                            Input a positive number to increase the ROB. Use a negative number to indicate a reduction. If there is no change, enter zero.
                        </small><br />
                        <Label className='mb-0 form-label mt-2' htmlFor={`adjustment_quantity-${index}`}>
                            Adjustment quantity
                        </Label>
                        <Field name={`lubeOil.${index}.adjustment_quantity`} id={`adjustment_quantity-${index}`}>
                            {({ field }: FieldProps) => (
                                <div className="input-group">
                                    <Input
                                        onFocus={(e) => e.target.select()}
                                        {...field}
                                        type='text'
                                        className='form-control max-width-7'
                                        autoComplete="off"
                                        id={`adjustment_quantity-${index}`}
                                        onBlur={(e: any) => {
                                            handleBlur(e);
                                            handleChange(e);
                                        }}
                                        autoFocus
                                    />
                                    <div className="input-group-text">ltr</div>
                                </div>
                            )}
                        </Field>
                        {errors?.lubeOil?.[index]?.adjustment_quantity &&
                            touched?.lubeOil?.[index]?.adjustment_quantity &&
                            document.getElementById(`adjustment_quantity-${index}`) &&
                            state && (
                                <ErrorTooltip
                                    target={`adjustment_quantity-${index}`}
                                    message={errors.lubeOil[index].adjustment_quantity}
                                    open={true}
                                />
                            )}
                    </Col>
                </Row>
                <Row className='mb-2'>
                    <Col lg={12}>
                        <Label htmlFor={`adjustment_reason-${index}`} className='form-label mb-0'>
                            Reason for adjustment
                        </Label>
                        <Field name={`lubeOil.${index}.adjustment_reason`} id={`adjustment_reason-${index}`}>
                            {({ field }: FieldProps) => (
                                <textarea
                                    {...field}
                                    className='form-control'
                                    id={`adjustment_reason-${index}`}
                                    autoComplete="off"
                                    rows={3}
                                    onBlur={(e: any) => {
                                        handleBlur(e);
                                        handleChange(e);
                                    }}
                                    defaultValue={values?.lubeOil[index]?.adjustment_reason ?? null}
                                />
                            )}
                        </Field>
                        {errors?.lubeOil?.[index]?.adjustment_reason &&
                            touched?.lubeOil?.[index]?.adjustment_reason &&
                            document.getElementById(`adjustment_reason-${index}`) &&
                            state && (
                                <ErrorTooltip
                                    target={`adjustment_reason-${index}`}
                                    message={errors.lubeOil[index].adjustment_reason}
                                    open={true}
                                />
                            )}
                    </Col>
                </Row>
                <Row className='mt-2 mb-2'>
                    <Col lg={2}>
                        <Button
                            type='button'
                            color='primary'
                            onClick={() => {
                                tog_backdrop();
                                handleSave(index, values, setFieldValue);
                            }}
                            disabled={!!showToolTip() || !values?.lubeOil?.[index]?.adjustment_quantity}
                        >
                            Save
                        </Button>
                    </Col>
                </Row>
            </div>
        </Modal>
    );
};

export default LOAdjustmentPopUp;
